import {
  BlockUI,
  NgBlockUI
}                           from 'ng-block-ui';
import {
  Component,
  EventEmitter,
  Input,
  Output
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { HaynesProService }          from './haynes-pro.service';
import { HaynesProLaborOptionModel } from './typings/haynes-pro.labor-option';
import { HaynesProLaborTimeModel }   from './typings/haynes-pro.labor-time';
import { Table }                     from '../table/types/table';

@Component({
  styles: [require('./haynes-pro.maintenance-times.row.expanded.component.scss')],
  template: require('./haynes-pro.maintenance-times.row.expanded.component.html')
})

export class HaynesProMaintenanceTimesExpandedRowComponent {
  public laborTimes                    = [];
  public laborIncludedSettings : Table = {
    columns: [
      {
        field : 'name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
        }
      }
    ],
    pagination: {
      enabled: false
    },
    static: true
  };

  @BlockUI('haynesProMaintenanceTimesRowExpandedBlock') block : NgBlockUI;

  @Input() record          : any;
  @Input() rowExpansionData: any;
  @Input() viewMode        : boolean;

  @Output() onTimeAdd      : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();
  @Output() onTimeRemove   : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();

  constructor (
    private haynesProService: HaynesProService,
    public translateService : TranslateService
  ) {}

  get laborOptions () : any[] {
    return this.record?.__laborOptions || [];
  }

  get laborTimesIncluded () : any[] {
    return this.record?.__laborTimesIncluded || [];
  }

  handleLaborOptionSelection ( option : HaynesProLaborOptionModel ) : void {
    this.block.start();
    this.laborTimes = [];

    setTimeout(() => {
      this.laborTimes = this.haynesProService.removeTimesWithNoLabor(option.tasks);
      this.block.stop();
    }, 500);
  }

  ngOnInit () : void {
    if (typeof this.rowExpansionData === 'function') {
      this.rowExpansionData(this.record);
    }
  }

}